import React from "react";
import { AdminOobBackgroundCheckFilesView } from "./view";
import { styles } from "./styles";

export const AdminOobBackgroundCheckFiles = props => (
  <AdminOobBackgroundCheckFilesView {...props} styles={styles} />
);
